import { render, staticRenderFns } from "./SocialIcon.vue?vue&type=template&id=dd31a2d4"
import script from "./SocialIcon.vue?vue&type=script&lang=js"
export * from "./SocialIcon.vue?vue&type=script&lang=js"
import style0 from "./SocialIcon.vue?vue&type=style&index=0&id=dd31a2d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports